import { RatingType, UserRole } from '../../../../../shared/enums';

const data = {
  [RatingType.ONBOARDING]: () => ([
    { value: 0, key: 'introductoryCallWithEditor' },
    { value: 0, key: 'writerProposal' },
    { value: 0, key: 'introductoryCallWithWriter' },
  ]),

  [RatingType.OUTLINE]: (userRole) => ([
    { value: 0, key: 'storyStructure', visibleFor: [UserRole.EDITOR, UserRole.CUSTOMER] },
    { value: 0, key: 'toneOfVoice', visibleFor: [UserRole.EDITOR] },
    { value: 0, key: 'writingQuality', visibleFor: [UserRole.EDITOR, UserRole.CUSTOMER] },
  ]).filter((mark) => mark.visibleFor.includes(userRole)),

  [RatingType.DRAFT]: () => ([
    { value: 0, key: 'accuracy' },
    { value: 0, key: 'storyStructure' },
    { value: 0, key: 'toneOfVoice' },
    { value: 0, key: 'writingQuality' },
  ]),

  [RatingType.PROOF]: () => ([
    { value: 0, key: 'finalizingDraft' },
    { value: 0, key: 'uploadingPhotos' },
    { value: 0, key: 'finalDesignProofs' },
  ]),
};

export default (ratingType, userRole) => data[ratingType](userRole);
